export default "__VITE_ASSET__BeNArZyd__"